(function () {
  var allowedStatuses = { active: true, "sample-review": true };

  function absoluteUrl(path) {
    var base = window.FirgelliOriginalHost || window.location.origin;
    if (!path) return base;
    try {
      return new URL(path, base).toString();
    } catch (error) {
      return base;
    }
  }

  function renderError(message) {
    var mount = document.querySelector("[data-firgelli-tool-embed-mount]");
    if (!mount) return;
    mount.innerHTML = "";
    var box = document.createElement("div");
    box.className = "firgelli-embed-error";
    box.textContent = message;
    mount.appendChild(box);
  }

  function setCanonical(url) {
    var canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;
  }

  function setOpenGraph(tool, originalUrl) {
    document.title = tool.title + " | FIRGELLI";
    [
      ["og:title", tool.title + " | FIRGELLI"],
      ["og:type", "website"],
      ["og:url", originalUrl],
      ["og:site_name", "FIRGELLI"]
    ].forEach(function (entry) {
      var tag = document.querySelector("meta[property='" + entry[0] + "']");
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", entry[0]);
        document.head.appendChild(tag);
      }
      tag.content = entry[1];
    });
  }

  function setStructuredData(tool, originalUrl) {
    var brandUrl = window.FirgelliOriginalHost || window.location.origin;
    var schema = {
      "@context": "https://schema.org",
      "@type": tool.type === "animated-diagram-only" ? "CreativeWork" : "WebApplication",
      "name": tool.title,
      "url": originalUrl,
      "applicationCategory": tool.type === "standard-calculator" ? "CalculatorApplication" : "EngineeringApplication",
      "isPartOf": {
        "@type": "WebSite",
        "name": "FIRGELLI",
        "url": brandUrl
      },
      "publisher": {
        "@type": "Organization",
        "name": "FIRGELLI",
        "url": brandUrl
      }
    };

    var tag = document.querySelector("script[data-firgelli-embed-schema]");
    if (!tag) {
      tag = document.createElement("script");
      tag.type = "application/ld+json";
      tag.dataset.firgelliEmbedSchema = "true";
      document.head.appendChild(tag);
    }
    tag.textContent = JSON.stringify(schema);
  }

  function absolutizeAttributes(root, baseUrl) {
    root.querySelectorAll("[src]").forEach(function (node) {
      node.setAttribute("src", absoluteAgainst(node.getAttribute("src"), baseUrl));
    });

    root.querySelectorAll("[href]").forEach(function (node) {
      var href = node.getAttribute("href");
      if (!href || href.charAt(0) === "#" || /^mailto:|^tel:/i.test(href)) return;
      node.setAttribute("href", absoluteAgainst(href, baseUrl));
    });

    root.querySelectorAll("[srcset]").forEach(function (node) {
      var srcset = node.getAttribute("srcset");
      node.setAttribute("srcset", srcset.split(",").map(function (part) {
        var pieces = part.trim().split(/\s+/);
        if (!pieces[0]) return "";
        pieces[0] = absoluteAgainst(pieces[0], baseUrl);
        return pieces.join(" ");
      }).filter(Boolean).join(", "));
    });
  }

  function absoluteAgainst(value, baseUrl) {
    try {
      return new URL(value, baseUrl).toString();
    } catch (error) {
      return value;
    }
  }

  function installSourceStyles(sourceDoc, baseUrl) {
    sourceDoc.querySelectorAll("link[rel='stylesheet']").forEach(function (link) {
      var href = link.getAttribute("href");
      if (!href) return;
      var resolved = absoluteAgainst(href, baseUrl);
      var alreadyLoaded = Array.prototype.some.call(document.querySelectorAll("link[data-firgelli-source-style]"), function (existing) {
        return existing.href === resolved;
      });
      if (alreadyLoaded) return;
      var clone = document.createElement("link");
      clone.rel = "stylesheet";
      clone.href = resolved;
      clone.dataset.firgelliSourceStyle = "true";
      document.head.appendChild(clone);
    });

    sourceDoc.querySelectorAll("style").forEach(function (style, index) {
      var clone = document.createElement("style");
      clone.dataset.firgelliSourceStyle = "inline-" + index;
      clone.textContent = style.textContent;
      document.head.appendChild(clone);
    });
  }

  function isJavaScriptType(script) {
    var type = (script.getAttribute("type") || "").trim().toLowerCase();
    return !type || type === "text/javascript" || type === "application/javascript" || type === "module";
  }

  function relevantScript(script, tool, selectorToken, localIds) {
    if (!isJavaScriptType(script)) return false;

    var src = script.getAttribute("src") || "";
    var code = script.textContent || "";
    var haystack = (src + "\n" + code).toLowerCase();
    var slug = (tool.sourceSlug || tool.slug || "").toLowerCase();
    var idToken = (selectorToken || "").toLowerCase();

    if (src) {
      if (/shopify|gtm|google|facebook|klaviyo|yotpo|judge|hotjar|analytics|recaptcha|header-all|vendor|theme/i.test(src)) return false;
      return (tool.requiredAssets || []).some(function (assetName) {
        return src.indexOf(assetName) !== -1;
      });
    }

    if (/Shopify\.|window\.Shopify|jiltStorefront|google_tag_manager|dataLayer|gtag|fbq\(/.test(code)) return false;
    if (slug && haystack.includes(slug)) return true;
    if (idToken && haystack.includes(idToken)) return true;
    if (localIds.some(function (id) {
      return id && haystack.includes(id.toLowerCase());
    })) return true;
    return /(requestanimationframe|data-fgmc|calculate|compute|function\s+draw|function\s+render|\.style\.transform|setattribute\s*\(\s*["']transform)/i.test(code);
  }

  function executeScript(script, baseUrl) {
    return new Promise(function (resolve) {
      var clone = document.createElement("script");
      var src = script.getAttribute("src");

      if (src) {
        clone.src = absoluteAgainst(src, baseUrl);
        clone.async = false;
        clone.onload = resolve;
        clone.onerror = resolve;
      } else {
        clone.textContent = script.textContent || "";
      }

      document.body.appendChild(clone);
      if (!src) resolve();
    });
  }

  function selectorToken(selector) {
    if (!selector) return "";
    if (selector.charAt(0) === "#") return selector.slice(1);
    var attrMatch = selector.match(/["']([^"']+)["']/);
    if (attrMatch) return attrMatch[1];
    var classMatch = selector.match(/\.([a-z0-9_-]+)/i);
    return classMatch ? classMatch[1] : "";
  }

  function stripEmbedArtifacts(root) {
    root.querySelectorAll(".firgelli-embed-button, [data-firgelli-embed-modal], script").forEach(function (node) {
      node.remove();
    });
  }

  function elementIds(root) {
    return Array.prototype.slice.call(root.querySelectorAll("[id]"))
      .map(function (node) {
        return node.id || "";
      })
      .filter(Boolean);
  }

  function standardCalculatorNode(sourceDoc) {
    var direct = sourceDoc.querySelector("div#calculator, section#calculator, form#calculator");
    if (direct) return direct;

    var heading = sourceDoc.querySelector("h1#calculator, h2#calculator, h3#calculator");
    if (!heading) return null;

    var sibling = heading.nextElementSibling;
    while (sibling) {
      if (sibling.matches && sibling.matches(".firgelli-embed-button, script, style")) {
        sibling = sibling.nextElementSibling;
        continue;
      }
      if (sibling.matches && sibling.matches("div, section, form")) return sibling;
      sibling = sibling.nextElementSibling;
    }

    return null;
  }

  function sourceNodeForTool(sourceDoc, tool) {
    if (tool.type === "standard-calculator" && tool.containerSelector === "#calculator + div") {
      var standard = standardCalculatorNode(sourceDoc);
      if (standard) return standard;
    }

    return sourceDoc.querySelector(tool.containerSelector);
  }

  function syncAttributionWidth(toolElement) {
    var attribution = document.querySelector("[data-firgelli-embed-attribution]");
    if (!attribution || !toolElement) return;

    function update() {
      var width = Math.ceil(toolElement.getBoundingClientRect().width);
      if (width > 0) {
        attribution.style.setProperty("--firgelli-attribution-width", width + "px");
      }
    }

    update();

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(update);
      observer.observe(toolElement);
    } else {
      window.addEventListener("resize", update);
    }
  }

  async function loadToolFromOriginalPage(tool, mount) {
    var originalUrl = absoluteUrl(tool.originalUrl);
    var sourceUrl = originalUrl;
    if (window.FirgelliToolSourceEndpoint) {
      sourceUrl = absoluteAgainst(window.FirgelliToolSourceEndpoint, window.location.href);
      sourceUrl += (sourceUrl.indexOf("?") === -1 ? "?" : "&") + "tool=" + encodeURIComponent(tool.slug);
    }
    var response = await fetch(sourceUrl, { credentials: "omit" });
    if (!response.ok) throw new Error("Could not fetch original page.");

    var html = await response.text();
    var sourceDoc = new DOMParser().parseFromString(html, "text/html");
    var sourceNode = sourceNodeForTool(sourceDoc, tool);
    if (!sourceNode) throw new Error("Registered tool container was not found.");

    installSourceStyles(sourceDoc, originalUrl);

    var clone = sourceNode.cloneNode(true);
    stripEmbedArtifacts(clone);
    absolutizeAttributes(clone, originalUrl);
    clone.dataset.firgelliEmbeddedTool = tool.slug;
    var localIds = elementIds(clone);

    mount.innerHTML = "";
    mount.appendChild(clone);
    syncAttributionWidth(clone);

    var token = selectorToken(tool.containerSelector);
    var scripts = Array.prototype.slice.call(sourceDoc.querySelectorAll("script"))
      .filter(function (script) {
        return relevantScript(script, tool, token, localIds);
      });

    for (var i = 0; i < scripts.length; i += 1) {
      await executeScript(scripts[i], originalUrl);
    }

    window.dispatchEvent(new CustomEvent("firgelli:tool-embed:mounted", {
      detail: { tool: tool, element: clone }
    }));
  }

  function track(eventName, tool, extra) {
    if (!window.FirgelliEmbedAnalytics || typeof window.FirgelliEmbedAnalytics.track !== "function") return;
    window.FirgelliEmbedAnalytics.track(eventName, Object.assign({
      calculatorSlug: tool.slug,
      calculatorType: tool.type,
      height: tool.height
    }, extra || {}));
  }

  function init() {
    var params = new URLSearchParams(window.location.search);
    var slug = params.get("tool");
    var registry = window.FirgelliToolRegistry || {};
    var tool = slug ? registry[slug] : null;
    var mount = document.querySelector("[data-firgelli-tool-embed-mount]");

    if (!tool || !allowedStatuses[tool.status]) {
      renderError("This FIRGELLI tool embed is not available.");
      return;
    }

    var originalUrl = absoluteUrl(tool.originalUrl);
    setCanonical(originalUrl);
    setOpenGraph(tool, originalUrl);
    setStructuredData(tool, originalUrl);

    var poweredLink = document.querySelector("[data-firgelli-powered-link]");
    var fullLink = document.querySelector("[data-firgelli-full-link]");
    var attribution = document.querySelector("[data-firgelli-embed-attribution]");
    if (poweredLink) poweredLink.href = originalUrl;
    if (fullLink) fullLink.href = originalUrl;
    if (attribution) attribution.hidden = false;

    if (poweredLink) {
      poweredLink.addEventListener("click", function () {
        track("attribution_click", tool, { linkLabel: "powered_by" });
      });
    }

    if (fullLink) {
      fullLink.addEventListener("click", function () {
        track("full_calculator_click", tool, { linkLabel: "view_full_calculator" });
      });
    }

    if (!window.FirgelliDisableClientIframeLoad) {
      track("iframe_load", tool);
    }

    loadToolFromOriginalPage(tool, mount).catch(function (error) {
      renderError(error.message || "This FIRGELLI tool could not be loaded.");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
